// splitTextByByteLength.js
'use strict';

/**
 * Break down long text into small groups (to avoid hitting size limitation for some services, e.g., Sentry)
 * @param {string} {text} - the long text to be splitted
 * @param {number} {maxBytes} - the expected maximum group size in bytes
 * @return {array} splitted results
 */
function splitTextByByteLength(text, maxBytes) {
  const encoder = new TextEncoder();
  const chunks = [];
  let currentBytes = 0;
  let currentChunk = '';

  for (const char of text) {
    const encodedChar = encoder.encode(char);
    if (currentBytes + encodedChar.length > maxBytes) {
      chunks.push(currentChunk);
      currentChunk = char;
      currentBytes = encodedChar.length;
    } else {
      currentChunk += char;
      currentBytes += encodedChar.length;
    }
  }

  if (currentChunk) chunks.push(currentChunk);

  return chunks;
}

export default splitTextByByteLength;
